var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
// eslint-disable-next-line import/no-extraneous-dependencies
import { get as _get, set as _set } from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as yup from 'yup';
import create from 'zustand';
// Determine what value we should use from an event that an input emits to us
export function resolveValue(event) {
    if (Boolean(event) && event.target !== undefined) {
        switch (event.target.tagName) {
            case 'INPUT':
                return resolveTextInputValue(event);
            default:
                return event.target.value;
        }
    }
    return event;
}
export function resolveTextInputValue(event) {
    switch (event.target.type) {
        case 'checkbox':
            return event.target.checked;
        default:
            return event.target.value;
    }
}
export function useFormFieldErrorMessage(name, value, schema, isDirty, options) {
    return React.useMemo(function () {
        try {
            if (isDirty && (options === null || options === void 0 ? void 0 : options.validate)) {
                if (options && options.valueProvider) {
                    schema.validateSyncAt(name, options.valueProvider());
                }
                else {
                    yup.reach(schema, name).validateSync(value);
                }
            }
        }
        catch (error) {
            console.error(error);
            return error.message;
        }
        return undefined;
    }, [value, isDirty, schema]);
}
export function createStore(defaultValues, schema) {
    return create(function (set, get) { return (__assign(__assign({}, defaultValues), { schema: schema, dirtyFields: [], isValid: false, addDirty: function (name) {
            set(function (state) {
                return !state.dirtyFields.some(function (x) { return x === name; })
                    ? __assign(__assign({}, state), { dirtyFields: __spreadArray(__spreadArray([], state.dirtyFields, true), [name], false) }) : state;
            });
        }, isDirty: function (name) {
            return name
                ? get().dirtyFields.some(function (x) { return x === name || x.startsWith("".concat(name, ".")); })
                : get().dirtyFields.length > 0;
        }, isSectionDirty: function (path, sectionKey) {
            if (sectionKey === void 0) { sectionKey = null; }
            // eslint-disable-next-line @typescript-eslint/no-shadow
            var _a = get(), schema = _a.schema, dirtyFields = _a.dirtyFields, getValues = _a.getValues;
            var fields = yup.reach(schema, path, getValues()).fields;
            var keys = Object.keys(fields);
            return keys
                .filter(function (key) { var _a, _b; return ((_b = (_a = fields[key].describe()) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.section) === (sectionKey !== null && sectionKey !== void 0 ? sectionKey : path); })
                .some(function (key) { return dirtyFields.some(function (field) { return field === "".concat(path, ".").concat(key); }); });
        }, markClean: function (path) {
            set(function (state) { return (__assign(__assign({}, state), { dirtyFields: path
                    ? state.dirtyFields.filter(function (field) { return !field.startsWith(path) && field !== path; })
                    : [] })); });
        }, updateField: function (path, value, options) {
            if (options === void 0) { options = { markDirty: true }; }
            set(produce(function (state) {
                _set(state, path, value);
                // eslint-disable-next-line no-param-reassign
                state.isValid = state.schema.isValidSync(state);
            }));
            if (options.markDirty) {
                get().addDirty(path);
            }
        }, updateStore: function (fn) {
            set(produce(function (state) {
                fn(state);
                // eslint-disable-next-line no-param-reassign
                state.isValid = state.schema.isValidSync(state);
            }));
        }, getValues: function () {
            var values = get();
            var newValues = {};
            Object.keys(defaultValues).forEach(function (key) {
                newValues[key] = values[key];
            });
            return newValues;
        }, getValue: function (path) {
            var values = get();
            return _get(values, path);
        }, reset: function () {
            set(function (state) {
                var newState = __assign(__assign(__assign({}, state), { dirtyFields: [] }), defaultValues);
                newState.isValid = state.schema.isValidSync(newState);
                return newState;
            });
        } })); });
}
